export const endPoints = {
  PIPE: '/v1/pipe',
  PIPE_TEMPLATE_ALL: '/v1/pipe/template/all',
  PIPE_CAUSE: '/v1/pipe/template/cause',
  PIPE_TEMPLATE: 'v1/pipe/template'
};
